export default "__VITE_ASSET__BEBVL5zY__"